import Vue from 'vue';
import Router from 'vue-router'; /* 导入路由 */
/* 导入组件 */
// import Login from '../Login.vue';
// import Main from '../Main.vue';
import CourseListIndex from '@/views/courseList/index.vue'
//安装路由
Vue.use(Router)
/* 定义组件路由 */
export const routesArray = [
	{
		path: "/",
		component: () => import("@/views/home"),
		name: 'jia1',
		redirect: '/list',
		children: [
			{
			  path: 'list',
			  name: 'course',
			  component: () => import("@/views/courseList"), // 注意这里是将 CourseListIndex 组件设置为 Home 组件的子路由
			  meta: { title: '' },
			},
			{
			  path: 'detail',
			  name: 'course',
			  component: () => import("@/views/courseList/courseDetail.vue"), // 注意这里是将 CourseListIndex 组件设置为 Home 组件的子路由
			},
			{
			  path: 'appDownInfo',
			  name: 'down',
			  component: () => import("@/views/appDownInfo/appDownInfo.vue"), // 注意这里是将 CourseListIndex 组件设置为 Home 组件的子路由
			},
			{
			  path: '/agreement',
			  component: () => import('@/views/agreement'),
			  hidden: true
			},
		]
	},
	
]
const router = new Router({
	// mode: 'history', // require service support
	routes: routesArray,
	scrollBehavior: () => ({
		y: 0
	}),
});
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '学到头秃的营养小白';
  next();
});

// const router = createRouter();
//导出路由对象
export default router;